import React, { useEffect, useState, useRef } from "react";
import Styles from "../../../assets/css/Blogs/RealLifeGadgets/PushUpBoard.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const PushUpBoard = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const PushUpBoard = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/RealLifeGadgets/PushUpBoard",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./12.avif"),
    ProductImages("./16.avif"),
    ProductImages("./17.avif"),
    ProductImages("./18.avif"),
    ProductImages("./19.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (PushUpBoard.current) {
        const { width, height } = PushUpBoard.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Push-Up Board Gadget - Build Strength & Boost Health 💪</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover the Push-Up Board Gadget – your ultimate fitness partner. Build strength, improve posture, and achieve your fitness goals with ease."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Push-Up Board Gadget, Home Workout Equipment, Strength Training, Fitness Gear, Bodyweight Exercises, Muscle Building"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Push-Up Board Gadget - Build Strength & Boost Health 💪"
        />
        <meta
          property="og:description"
          content="Discover the Push-Up Board Gadget – your ultimate fitness partner. Build strength, improve posture, and achieve your fitness goals with ease."
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/reallifegadgets/pushupboard"
        />
        {/* <meta property="og:image" content="/images/PushUpBoard/12.webp" /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Push-Up Board Gadget - Build Strength & Boost Health 💪"
        />
        <meta
          name="twitter:description"
          content="Discover the Push-Up Board Gadget – your ultimate fitness partner. Build strength, improve posture, and achieve your fitness goals with ease."
        />
        {/* <meta name="twitter:image" content="/images/PushUpBoard/12.webp" /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/reallifegadgets/pushupboard"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div ref={PushUpBoard} className={Styles.PushUpBoardContainer}>
        <section className={Styles.PushUpBoardSection1}>
          <div className={Styles.PushUpBoardSection1Text1Container}>
            {/* <h1>Push-Up Board That Transforms Your Workouts 🚀</h1> */}
          </div>
          <img
            src={`${ProductImagesArray[0]}`}
            alt="Push Up Board"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.PushUpBoardSection1Text2Container}>
            <h1>| Push Up Board |</h1>
            <h1>Build Strength, Boost Health, Live Better 💪</h1>
            <p>
              Staying active is the key to a stronger, healthier life! Push-ups
              are a simple yet powerful exercise that strengthens muscles,
              improves posture, and boosts overall fitness. Regular workouts
              help increase energy, reduce stress, and support heart health,
              making daily activities easier and more enjoyable. With the right
              training tools, you can stay fit, feel great, and build a
              healthier future—all from the comfort of your home! 🚀
            </p>
          </div>
          <div className={Styles.PushUpBoardSection1Img2Container}>
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Push Up Board"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="Push Up Board"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.PushUpBoardSection1Text3Container}>
            <h1>What Makes the Push-Up Board Special? 🔥</h1>
            <p>
              ✅ Color-Coded Training System – Easily switch hand positions to
              focus on different muscle groups like the chest, triceps,
              shoulders, and back.
            </p>
            <p>
              ✅ Built for All Fitness Levels – Whether you're a beginner or an
              experienced athlete, this board adapts to your strength, helping
              you progress safely.
            </p>
            <p>
              ✅ Durable & Portable – Made with high-quality materials, this
              lightweight board is perfect for home workouts, office breaks, or
              travel fitness.
            </p>
            <p>
              ✅ Motivating & Engaging – Say goodbye to boring workouts! This
              push-up system adds variety and structure, keeping you consistent
              and motivated.
            </p>
          </div>
          <div className={Styles.PushUpBoardSection1Img3Container}>
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Push Up Board"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[4]}`}
              alt="Push Up Board"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.PushUpBoardSection1Text4Container}>
            <h1>Upgrade Your Workout Routine Today! 🎯</h1>
            <p>
              If you’re serious about building muscle, improving strength, and
              achieving fitness goals, the POSKOU Push-Up Board is a must-have.
              It’s an easy way to train smarter, stay consistent, and see real
              results from the comfort of your home.
            </p>
          </div>
          <div className={Styles.PushUpBoardSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/42YrP2O"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.PushUpBoardSection1BtnAmazonAncherContainer}
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.PushUpBoardSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div className={Styles.PushUpBoardSection1DesclaimerContainer}>
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #PushUpBoard #HomeWorkout #FitnessGear #StrengthTraining
              #BodyweightWorkout #ChestWorkout #FullBodyWorkout #GymAtHome
              #WorkoutEquipment #HealthyActivity
            </p>
            <h1>Keywords</h1>
            <p>
              Best push-up board for 2025 home workouts Multifunctional push-up
              board for full-body training Adjustable push-up board with
              color-coded positions Portable push-up board for strength and
              muscle building Heavy-duty push-up bar system for chest, arms, and
              core Non-slip push-up board for safe and effective
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default PushUpBoard;
